<template>
    <ComponentWithPropertiesInstance v-if="root" :key="root.key" :component="root" />
</template>

<script setup lang="ts">
import type { ComponentWithProperties } from '@browser/navigation';
import { ComponentWithPropertiesInstance } from '@browser/navigation';
import type { Ref } from 'vue';
import { computed, inject, unref } from 'vue';

// The InheritComponent allows you to define comonents in the 'provide' context tree, and display one of those components if it is present
// This allows you to keep logic outside of components and 'inject' them

const props = defineProps<{
    name: string;
    overrideProps?: Record<string, any>;
}>();

const injectedComponents = inject('reactive_components') as Ref<Map<string, ComponentWithProperties | null> | undefined> | undefined;
const root = computed(() => {
    const injected = unref(injectedComponents);
    if (injected?.get(props.name)) {
        // We need to clone here, because the component might be in multiple places
        const unreffed = unref(injected.get(props.name));
        const c = unreffed?.deepClone() ?? null;
        if (c) {
            if (props.overrideProps) {
                c.properties = {
                    ...c.properties,
                    ...props.overrideProps,
                };
            }
            return c;
        }
    }
    return null;
});

</script>
